import React from 'react';
import TemplateItem from './TemplateItem';
import { Template } from '../../../@types/domain';
import * as S from '../style';

type TemplatesProperties = {
  templates: Template[];
  activeTemplateId?: string;
  onTemplateSelected: (template?: Template | undefined) => void;
};

function Templates({
  templates,
  activeTemplateId,
  onTemplateSelected,
}: TemplatesProperties) {
  return (
    <S.TemplateList>
      {templates.map((t) => (
        <TemplateItem
          key={t.id}
          template={t}
          isActive={t.id === activeTemplateId}
          onClick={onTemplateSelected}
        />
      ))}
    </S.TemplateList>
  );
}

export default Templates;
